export enum SLOT {
  LANDING = "landing",
  THREE_YEAR_PLAN = "three-year-plan",
  OUTAGE_MONITORING = "incident-management",
  GRID_CONNECTION = "grid-connections",
  ACCOUNTING = "accounting",
  GRID_SCENARIOS = "grid-scenarios"
}
